import React from 'react';
import iconCard from '../../images/icon-card.svg';
import iconSearch from '../../images/icon-search.svg';
import iconDanger from '../../images/icon-danger.svg';
import iconStop from '../../images/icon-stop.svg';
import { useNavigate } from "react-router-dom";

export default function CardCompany2({ setPassCard }: any) {
  const navigate = useNavigate();
  const passcardHandler = () => setPassCard(true);
  const safetyHandler = () => {
    navigate('/safetyCheck');
  };
  const dangerHandler = () => { navigate('/danger-evaluation') };
  const workstopHandler = () => {
    navigate('/stop-request', { state: { isRequest: true } });
  };
  return (
    <>
      <div className='flex mt-[0.68rem] md:mt-[1.7rem]'>
        <div
          onClick={passcardHandler}
          className='hover:cursor-pointer flex justify-between w-[49%] bg-[#2f2f35] rounded-[8px] md:rounded-[20px] mr-[0.688rem] md:mr-[1.72rem] whitespace-pre-line'>
          <img className='w-[3.56rem] h-[3.56rem] md:w-[8.9rem] md:h-[8.9rem] mt-[0.125rem] md:mt-[0.312rem] ml-[0.2rem] sm:ml-[0.5rem] md:ml-[1.25rem]' src={iconCard} alt='icon1' />
          <p className='text-[0.75rem] sm:text-[0.938rem] md:text-[2.2rem] text-right font-semibold mr-[0.5rem] md:mr-[1.25rem] -ml-[2rem] md:-ml-[5rem] mt-[3.125rem] sm:mt-[5rem] md:mt-[12.5rem] mb-[1rem] md:mb-[2.5rem]'>내 출입증 확인</p>
        </div>
        <div
          onClick={safetyHandler}
          className='hover:cursor-pointer flex justify-between w-[49%] bg-[#2f2f35] rounded-[8px] md:rounded-[20px]'>
          <img className='w-[3.56rem] h-[3.56rem] md:w-[8.9rem] md:h-[8.9rem] mt-[0.313rem] md:mt-[0.782rem] ml-[0.2rem] sm:ml-[0.5rem] md:ml-[1.25rem]' src={iconSearch} alt='icon2' />
          <p className='text-[0.75rem] sm:text-[0.938rem] md:text-[2.2rem] text-right font-semibold mr-[0.5rem] md:mr-[1.25rem] -ml-[2rem] md:-ml-[5rem] mt-[4.375rem] sm:mt-[5rem] md:mt-[12.5rem] mb-[1rem] md:mb-[2.5rem]'>안전점검</p>
        </div>
      </div>
      <div className='flex mt-[0.68rem] md:mt-[1.7rem]'>
        <div
          onClick={dangerHandler}
          className='hover:cursor-pointer flex justify-between w-[49%] bg-[#2f2f35] rounded-[8px] md:rounded-[20px] mr-[0.688rem] md:mr-[1.72rem]'>
          <img className='w-[3.56rem] h-[3.56rem] md:w-[8.9rem] md:h-[8.9rem] mt-[0.313rem] md:mt-[0.782rem] ml-[0.2rem] sm:ml-[0.5rem] md:ml-[1.25rem]' src={iconDanger} alt='icon3' />
          <p className='text-[0.75rem] sm:text-[0.938rem] md:text-[2.2rem] text-right font-semibold mr-[0.5rem] md:mr-[1.25rem]  -ml-[1rem] md:-ml-[2.5rem] mt-[4.375rem] sm:mt-[5rem] md:mt-[12.5rem] mb-[1rem] md:mb-[2.5rem]'>위험성평가</p>
        </div>
        <div
          onClick={workstopHandler}
          className='hover:cursor-pointer flex justify-between w-[49%] bg-[#2f2f35] rounded-[8px] md:rounded-[20px]'>
          <img className='w-[3.56rem] h-[3.56rem] md:w-[8.9rem] md:h-[8.9rem] mt-[0.313rem] md:mt-[0.782rem] ml-[0.2rem] sm:ml-[0.5rem] md:ml-[1.25rem]' src={iconStop} alt='icon4' />
          <p className='text-[0.75rem] sm:text-[0.938rem] md:text-[2.2rem] text-right font-semibold mr-[0.5rem] md:mr-[1.25rem] -ml-[1rem] md:-ml-[2.5rem] mt-[4.375rem] sm:mt-[5rem] md:mt-[12.5rem] mb-[1rem] md:mb-[2.5rem]'>작업중지요청</p>
        </div>
      </div>
    </>
  );
}

